import React, { useState, useEffect } from "react";
import axios from "../../api/axios";
import requests from "../../api/Requests";
import "./Banner.css";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlay, faInfoCircle, faStar } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import TrailerModal from "../TrailerModal/TrailerModal";

function Banner({ movie: propMovie, fetchUrl }) {
	const [movies, setMovie] = useState([]);
	const [trailerMovieId, setTrailerMovieId] = useState(null);

	useEffect(() => {
		if (propMovie) return;
		async function fetchDate() {
			const url = fetchUrl || requests.fetchNetflixOriginals;
			const request = await axios.get(url);
			setMovie(request.data.results);
			return request;
		}
		fetchDate();
	}, [propMovie, fetchUrl]); // eslint-disable-line react-hooks/exhaustive-deps

	function truncate(str, n) {
		return str?.length > n ? str.substr(0, n - 1) + "..." : str;
	}

	const getYear = (item) => {
		const date = item?.first_air_date || item?.release_date;
		return date ? date.split("-")[0] : "";
	};

	const getRating = (item) => {
		return item?.vote_average ? item.vote_average.toFixed(1) : null;
	};

	const handlePlayTrailer = (e, movieId) => {
		e.stopPropagation();
		setTrailerMovieId(movieId);
	};

	const opts = {
		autoplay: true,
		infinite: true,
		autoplaySpeed: 5000,
		speed: 600,
		slidesToShow: 1,
		slidesToScroll: 1,
		pauseOnFocus: true,
		pauseOnHover: true,
		dots: true,
		arrows: false,
		cssEase: "cubic-bezier(0.16, 1, 0.3, 1)",
	};

	// If used as movie detail banner
	if (propMovie) {
		const m = propMovie;
		return (
			<>
				<div
					className="banner banner-movie"
					style={{
						backgroundSize: "cover",
						backgroundImage: `url("https://image.tmdb.org/t/p/original/${m?.backdrop_path}")`,
						backgroundPosition: "center center",
					}}
				>
					<div className="banner__contents">
						{m.networks && (
							<div className="network_logo">
								{m.networks.map((network) => (
									<img
										key={network?.id}
										src={`https://image.tmdb.org/t/p/original/${network?.logo_path}`}
										alt={network?.name}
									/>
								))}
							</div>
						)}
						<h1 className="banner__title">
							{m.title || m?.name || m?.original_name}
						</h1>

						<div className="banner__info-row">
							{getRating(m) && (
								<span className="banner__rating">
									<FontAwesomeIcon icon={faStar} style={{ fontSize: '11px' }} />
									{getRating(m)}
								</span>
							)}
							{(m.first_air_date || m.release_date) && (
								<span className="banner__info-item">{getYear(m)}</span>
							)}
							{m.original_language && (
								<span className="banner__info-item banner__info-item--language">
									{m.original_language}
								</span>
							)}
							{m.runtime > 0 && (
								<span className="banner__info-item">
									{Math.floor(m.runtime / 60)}h {m.runtime % 60}m
								</span>
							)}
							{m.number_of_episodes && (
								<span className="banner__info-item">{m.number_of_episodes} Episodes</span>
							)}
							{m.number_of_seasons && (
								<span className="banner__info-item">{m.number_of_seasons} Seasons</span>
							)}
						</div>

						{m.genres && (
							<div className="banner__genres">
								{m.genres.map((genre) => (
									<span key={genre?.id} className="banner__genre-tag">
										{genre?.name}
									</span>
								))}
							</div>
						)}

						{m.overview && (
							<p className="banner__description">
								{truncate(m?.overview, 300)}
							</p>
						)}

						{m.status && (
							<div className="banner__status">
								<span className="banner__status-dot" />
								{m.status}
							</div>
						)}

						<div className="banner__buttons">
							<button
								className="banner__button banner__button--primary"
								onClick={(e) => handlePlayTrailer(e, m.id)}
							>
								<FontAwesomeIcon icon={faPlay} />
								Play Trailer
							</button>
							<Link to={`/movie/${m.id}`} className="banner__button banner__button--secondary">
								<FontAwesomeIcon icon={faInfoCircle} />
								More Info
							</Link>
						</div>
					</div>
				</div>

				{trailerMovieId && (
					<TrailerModal
						movieId={trailerMovieId}
						onClose={() => setTrailerMovieId(null)}
					/>
				)}
			</>
		);
	}

	// Hero slider
	return (
		<>
			<Slider {...opts}>
				{movies.map((movie) => (
					<div className="slide-itm" key={movie.id}>
						<div
							className="banner"
							style={{
								backgroundSize: "cover",
								backgroundImage: `url("https://image.tmdb.org/t/p/original/${movie?.backdrop_path || movie?.poster_path}")`,
								backgroundPosition: "center center",
							}}
						>
							<div className="banner__contents">
								<div className="banner__meta">
									{getRating(movie) && (
										<span className="banner__rating">
											<FontAwesomeIcon icon={faStar} style={{ fontSize: '11px' }} />
											{getRating(movie)}
										</span>
									)}
									<span className="banner__year">{getYear(movie)}</span>
									<span className="banner__type">
										{movie.media_type === "tv" || movie.first_air_date ? "TV Series" : "Movie"}
									</span>
								</div>

								<h1 className="banner__title">
									{movie.title || movie?.name || movie?.original_name}
								</h1>

								<p className="banner__description">
									{truncate(movie?.overview, 200)}
								</p>

								<div className="banner__buttons">
									<button
										className="banner__button banner__button--primary"
										onClick={(e) => handlePlayTrailer(e, movie.id)}
									>
										<FontAwesomeIcon icon={faPlay} />
										Play
									</button>
									<Link
										to={`/movie/${movie.id}`}
										className="banner__button banner__button--secondary"
									>
										<FontAwesomeIcon icon={faInfoCircle} />
										More Info
									</Link>
								</div>
							</div>
						</div>
					</div>
				))}
			</Slider>

			{trailerMovieId && (
				<TrailerModal
					movieId={trailerMovieId}
					onClose={() => setTrailerMovieId(null)}
				/>
			)}
		</>
	);
}

export default Banner;
